/**
 * @file: index.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export * from './ConstructionReport';
export * from './ConstructionReportItem';
export * from './ConstructionReportItemDetail';
export * from './DeliveryCheckReport';
export * from './DeliveryCheckReportItem';
export * from './DiagnosticTroubleCode';
export * from './InspectionReport';
export * from './InspectionReportItem';
export * from './MediaInfo';
export * from './PendingIssue';
export * from './ReportProductReferral';
export * from './ReportSaveResult';
export * from './ReportStatus';
export * from './VehicleReport';
export * from './VehicleReportFilter';
